module.exports = __webpack_public_path__ + "images/ad9e75bb7b7d2fa05f5b7393f11d960e-IMG_8221.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_8221.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_8221.jpg
// module chunks = 0